module.exports = __webpack_public_path__ + "static/img/企业展示馆.9d891763.png";